export default __webpack_public_path__ + "static/media/logo-black.c9d69acf.png";